import { render } from "./app.vue?vue&type=template&id=058f78a8&ts=true"
import script from "./app.vue?vue&type=script&lang=ts"
export * from "./app.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\ProjectsLaravel\\nft_imw_v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/ts/frontend/app.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "058f78a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('058f78a8', __exports__)) {
    console.log('reload')
    api.reload('058f78a8', __exports__)
  }
  
  module.hot.accept("./app.vue?vue&type=template&id=058f78a8&ts=true", () => {
    console.log('re-render')
    api.rerender('058f78a8', render)
  })

}


export default __exports__